import _ from 'lodash';
import { sqWorkbenchStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { useLicense } from '@/licenseManagement/licenseManagement.store';
import { initializeTrackers } from '@/track/track.service';

/**
 * Tracker is responsible for initializing the Telemetry trackers.
 *
 * This component was created to ensure that all tracking events use current store data.
 */
export const Tracker = () => {
  const currentUser = useFluxPath(sqWorkbenchStore, () => sqWorkbenchStore.currentUser);
  const darkMode = useFluxPath(sqWorkbenchStore, () => sqWorkbenchStore.darkMode);
  const userLanguage = useFluxPath(sqWorkbenchStore, () => sqWorkbenchStore.userLanguage);
  const license = useLicense();

  if (!_.isEmpty(license) && currentUser) {
    initializeTrackers(currentUser, darkMode, userLanguage, license as any);
  }

  return null;
};
